export const jobArray = [
    {id: "1", code: "JOB_ARTISTIC", detail: "Artistic"},
    {id: "2", code: "JOB_BANK", detail: "Bank"},
    {id: "3", code: "JOB_CLERICAL", detail: "Clerical"},
    {id: "4", code: "JOB_MANAGEMENT", detail: "Management"},
    {id: "5", code: "JOB_EXECUTIVE", detail: "Executive"},
    {id: "6", code: "JOB_FINANCIAL", detail: "Financial"},
    {id: "7", code: "JOB_LEGAL", detail: "Legal"},
    {id: "8", code: "JOB_MEDIA", detail: "Teacher"},
    {id: "9", code: "JOB_TRAVEL", detail: "Travel"},
    {id: "10", code: "JOB_MANFACTURING", detail: "Manfacturing"},
    {id: "11", code: "JOB_MEDICAL", detail: "Medical"},
    {id: "12", code: "JOB_NURSE", detail: "Nurse"},
    {id: "13", code: "JOB_DOCTOR", detail: "Doctor"},
    {id: "14", code: "JOB_SALES", detail: "Sales"},
    {id: "15", code: "JOB_MARKETING", detail: "Marketing"},
    {id: "16", code: "JOB_TECHNICAL", detail: "Technical"},
    {id: "17", code: "JOB_CONSULTANT", detail: "Consultant"},
    {id: "18", code: "JOB_TRANSPORTATION", detail: "Transportation"},
    {id: "19", code: "JOB_FOOD", detail: "Food"},
    {id: "20", code: "JOB_BARTENDER", detail: "Bartender"},
    {id: "21", code: "JOB_STRIPPER", detail: "Stripper"},
    {id: "22", code: "JOB_DANCER", detail: "Dancer"},
    {id: "23", code: "JOB_CONSTRUCTION", detail: "Construction"},
    {id: "24", code: "JOB_RETIRED", detail: "Retired"},
    {id: "25", code: "JOB_ENTREPRENEUR", detail: "Entrepreneur"},
    {id: "26", code: "JOB_PROSPORTS", detail: "Pro Sports"},
    {id: "27", code: "JOB_OTHER", detail: "Other"},
    {id: "28", code: "JOB_COMPTERSOFTWARE", detail: "Compter Software"},
    {id: "29", code: "JOB_COMPUTERHARDWARE", detail: "Computer Hardware "},
    {id: "30", code: "JOB_COMPUTERCONSULTANT", detail: "Computer Consultant"}
  ];

  export const heightFeetArray = [
    {id: "3"},
    {id: "4"},
    {id: "5"},
    {id: "6"},
    {id: "7"},
    {id: "8"}
  ];

  export const heightInchArray = [
    {id: "3"},
    {id: "4"},
    {id: "5"},
    {id: "6"},
    {id: "7"},
    {id: "8"},
    {id: "9"},
    {id: "10"},
    {id: "11"},
    {id: "12"}
  ];

  export const seekingArray = [
    {id: "1", code: "Male", detail: "Male"},
    {id: "2", code: "Female", detail: "Female"}
  ];
 
  export const myGenderArray = [
    {id: "1", code: "Male", detail: "Male"},
    {id: "2", code: "Female", detail: "Female"}
  ];

  export const ageStartArray = [
    {id: "18"},
    {id: "19"},
    {id: "20"},
    {id: "21"},
    {id: "22"},
    {id: "23"},
    {id: "24"},
    {id: "25"},
    {id: "26"},
    {id: "27"},
    {id: "28"},
    {id: "29"},
    {id: "30"},
    {id: "31"},
    {id: "32"},
    {id: "33"},
    {id: "34"},
    {id: "35"},
    {id: "36"},
    {id: "37"},
    {id: "38"},
    {id: "39"},
    {id: "40"},
    {id: "41"},
    {id: "42"},
    {id: "43"},
    {id: "44"},
    {id: "45"},
    {id: "46"},
    {id: "47"},
    {id: "48"},
    {id: "49"},
    {id: "50"},
    {id: "51"},
    {id: "52"},
    {id: "53"},
    {id: "54"},
    {id: "55"},
    {id: "56"},
    {id: "57"},
    {id: "58"},
    {id: "59"},
    {id: "60"},
    {id: "61"},
    {id: "62"},
    {id: "63"},
    {id: "64"},
    {id: "65"},
    {id: "66"},
    {id: "67"},
    {id: "68"},
    {id: "69"},
    {id: "70"},
    {id: "71"},
    {id: "72"},
    {id: "73"},
    {id: "74"},
    {id: "75"},
    {id: "76"},
    {id: "77"},
    {id: "78"},
    {id: "79"},
    {id: "80"},
    {id: "81"},
    {id: "82"},
    {id: "83"},
    {id: "84"},
    {id: "85"},
    {id: "86"},
    {id: "87"},
    {id: "88"},
    {id: "89"},
    {id: "90"},
    {id: "91"},
    {id: "92"},
    {id: "93"},
    {id: "94"},
    {id: "95"},
    {id: "96"},
    {id: "97"},
    {id: "98"},
    {id: "99"}
  ];
  
  export const ageEndArray = [
    {id: "18"},
    {id: "19"},
    {id: "20"},
    {id: "21"},
    {id: "22"},
    {id: "23"},
    {id: "24"},
    {id: "25"},
    {id: "26"},
    {id: "27"},
    {id: "28"},
    {id: "29"},
    {id: "30"},
    {id: "31"},
    {id: "32"},
    {id: "33"},
    {id: "34"},
    {id: "35"},
    {id: "36"},
    {id: "37"},
    {id: "38"},
    {id: "39"},
    {id: "40"},
    {id: "41"},
    {id: "42"},
    {id: "43"},
    {id: "44"},
    {id: "45"},
    {id: "46"},
    {id: "47"},
    {id: "48"},
    {id: "49"},
    {id: "50"},
    {id: "51"},
    {id: "52"},
    {id: "53"},
    {id: "54"},
    {id: "55"},
    {id: "56"},
    {id: "57"},
    {id: "58"},
    {id: "59"},
    {id: "60"},
    {id: "61"},
    {id: "62"},
    {id: "63"},
    {id: "64"},
    {id: "65"},
    {id: "66"},
    {id: "67"},
    {id: "68"},
    {id: "69"},
    {id: "70"},
    {id: "71"},
    {id: "72"},
    {id: "73"},
    {id: "74"},
    {id: "75"},
    {id: "76"},
    {id: "77"},
    {id: "78"},
    {id: "79"},
    {id: "80"},
    {id: "81"},
    {id: "82"},
    {id: "83"},
    {id: "84"},
    {id: "85"},
    {id: "86"},
    {id: "87"},
    {id: "88"},
    {id: "89"},
    {id: "90"},
    {id: "91"},
    {id: "92"},
    {id: "93"},
    {id: "94"},
    {id: "95"},
    {id: "96"},
    {id: "97"},
    {id: "98"},
    {id: "99"}
  ];